import { Address } from "@medusajs/medusa"
import React, { useEffect } from "react"

import { GetMarketplaceLoanPaymentOptionsResponse, CreateMarketplaceLoanResponse, CreateAddressRequest } from "@lib/clients/nelo-api-client"
import NeloButton from "@modules/common/components/nelo-button"
import { sendGoogleAnalyticsEvent } from "@modules/common/utils/analytics"
import { CartDetails } from "@modules/signup-and-order-flow/util/use-create-cart"

import InstallmentContainer from "./installment-container"
import LoanDetailsDisplay from "./loan-details-container"
import LoanNotesContainer from "./loan-notes-container"
import OrderSummary from "./order-details-display"
import AddressContainer from "./user-address-container"

interface LoanOptionsDisplayProps {
  cartId: string | null
  loanOptions: GetMarketplaceLoanPaymentOptionsResponse | null
  cartDetails: CartDetails | null
  onOptionSelect: (uuid: string) => void
  disableButton: boolean
  isLoading: boolean
  onCompleteLoan: () => void
  address: Address | null
  loanDetails: CreateMarketplaceLoanResponse | null
  submitAddress: (address: CreateAddressRequest) => void
  preSelectedInstallment?: number
}

const LoanOptionsDisplay: React.FC<LoanOptionsDisplayProps> = ({
  loanOptions,
  onOptionSelect,
  cartDetails,
  disableButton,
  isLoading,
  onCompleteLoan,
  address,
  loanDetails,
  submitAddress,
  preSelectedInstallment,
}) => {
  useEffect(() => {
    sendGoogleAnalyticsEvent("LOAN_OPTIONS_DISPLAY")
  }, [])
  return (
    <div className="h-screen overflow-y-auto rounded-lg border p-4 pt-32 lg:px-10">
      {loanOptions ? (
        <div>
          <h1 className="mb-4 text-4xl font-bold text-nelo-blue">Completa tu pedido</h1>
          <h3 className="font-nunito text-ui-fg-base">Selecciona tu plan de pagos y verifica la dirección de envío.</h3>
          <OrderSummary cartDetails={cartDetails} />
          <InstallmentContainer loanOptions={loanOptions} onOptionSelect={onOptionSelect} preSelectedInstallment={preSelectedInstallment} />
          <AddressContainer address={address ?? null} submitAddress={submitAddress} />
          <LoanDetailsDisplay loanDetails={loanDetails} />
          <LoanNotesContainer loanDetails={loanDetails} />
          <NeloButton
            onClick={onCompleteLoan}
            disabled={disableButton}
            variant="primary"
            className={`mb-20 mt-6 w-full ${disableButton ? "bg-ui-fg-muted hover:bg-ui-fg-muted" : ""}`}
            loading={isLoading}
          >
            Continuar
          </NeloButton>
        </div>
      ) : (
        <p className="mt-4 text-ui-fg-base">Cargando ...</p>
      )}
    </div>
  )
}

export default LoanOptionsDisplay
